import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import UnityGameDockApp from './UnityGameDockApp';

interface LeaveBreakoutRoomProps {
  onLeaveRoom: () => void;
  dockMode?: boolean;
}

const LeaveBreakoutRoom: React.FC<LeaveBreakoutRoomProps> = ({ onLeaveRoom, dockMode = true }) => {
  const handler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onLeaveRoom();
  };

  if (dockMode) {
    return (
      <UnityGameDockApp
        ariaLabel="Exit breakout room and return to main room"
        label="Exit"
        icon={<FaArrowLeft />}
        tileClassName="bg-gradient-to-br from-red-600 to-rose-900"
        onClick={handler}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={handler}
      className="flex items-center gap-2 rounded-lg bg-red-600 bg-opacity-80 px-4 py-2 font-semibold text-white shadow-lg transition-all duration-200 hover:bg-opacity-100"
      title="Exit Breakout Room"
    >
      <FaArrowLeft size={16} />
      Exit Breakout Room
    </button>
  );
};

export default LeaveBreakoutRoom;
